module.exports = "<div class=\"inmodal\">\n  <div class=\"color-line\"></div>\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title\">Approve</h4>\n  </div>\n  <div class=\"modal-body\">\n    <p>Approving <strong>{{$ctrl.items.length}}</strong> timesheet(s).</p>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.ok()\">Ok</button>\n    <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./client/pages/review/modals/approval/approval.html
// module id = 997
// module chunks = 0